import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import LoanDetailPageUI from './LoanDetailPageUI.js'

class LoanDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      loan: null,
    }
  }

  render() {
    return (
      <LoanDetailPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    Modal.setAppElement('body')
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.loanId !== this.props.match.params.loanId) {
      // clear the old loan so stale data isn't shown while the new one loads
      this.setState({ errorList: null, loan: null }, () => {
        this.getLoan(this.props.context)
      })
    }
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    if (response.errorList.length > 0 && response.errorList[0].errorCode === 'NotFound') {
      CacheManager.removeObject(CacheKeys.Loans(this.props.context.session.accountId))
      window.location.href = '/home'
      return
    }
    this.setState({
      errorList: response.errorList,
      loan: response.loan,
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    if (noBusy === 'noBusy')
      this.getLoan(context)
    else
      this.setState({
        errorList: null,
        loan: null,
      }, () => {
        this.getLoan(context)
      })
  }
}

export default withRouter(LoanDetailPageSF)
